// extracted by mini-css-extract-plugin
export default {"ClientDetail":"ClientDetail_ClientDetail__AnZV-","tableResponsive":"ClientDetail_tableResponsive__Sn1qi"};